import ContentLoader from 'react-content-loader'
import MediaQuery from 'react-responsive'

export const Skeleton = () => (
  <>
    <MediaQuery minWidth={768}>
      <ContentLoader
        speed={3}
        width={1190}
        height={85}
        viewBox="0 0 1190 76"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb">
        <rect x="16" y="10" rx="5" ry="5" width="700" height="26" />
        <rect x="16" y="50" rx="5" ry="5" width="300" height="18" />
      </ContentLoader>
    </MediaQuery>
    <MediaQuery maxWidth={767} minWidth={376}>
      <ContentLoader
        speed={3}
        width={1000}
        height={85}
        viewBox="0 0 1190 76"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb">
        <rect x="16" y="10" rx="5" ry="5" width="350" height="26" />
        <rect x="16" y="50" rx="5" ry="5" width="250" height="18" />
      </ContentLoader>
    </MediaQuery>
    <MediaQuery maxWidth={376} minWidth={321}>
      <ContentLoader
        speed={3}
        width={1000}
        height={85}
        viewBox="0 0 1190 76"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb">
        <rect x="16" y="10" rx="5" ry="5" width="320" height="26" />
        <rect x="16" y="50" rx="5" ry="5" width="230" height="18" />
      </ContentLoader>
    </MediaQuery>
    <MediaQuery maxWidth={320}>
      <ContentLoader
        speed={3}
        width={1000}
        height={85}
        viewBox="0 0 1190 76"
        backgroundColor="#f3f3f3"
        foregroundColor="#ecebeb">
        <rect x="16" y="10" rx="5" ry="5" width="280" height="26" />
        <rect x="16" y="50" rx="5" ry="5" width="200" height="18" />
      </ContentLoader>
    </MediaQuery>
  </>
)

export default Skeleton
